import styled from 'styled-components';
import { media } from '../../../common/styles/styleUtil';

export const PageWrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  margin-bottom: 40px;
`;

export const TextContentWrapper = styled.div`
  width: 1140px;
  margin: 0 auto;
  ${media.lg`
      width: 100%;
      padding: 0 24px;
  `}
  ${media.xs`
      padding: 0 16px;
  `};

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333f48;
  }
  .content {
    max-width: 750px;
    padding: 24px 0 32px 0;
    p {
      word-break: break-word;
    }
    img {
      width: 100%;
      max-width: 100%;
      height: 100%;
    }
  }
`;
